import type { Components, Theme } from "@mui/material";

import { dropdownPaperStyles } from "./dropdownPaperStyles.ts";

export const menuTheme: Components<Theme>["MuiMenu"] = {
  defaultProps: {
    elevation: 0,
  },
  styleOverrides: {
    // same theming as MuiSelect's dropdown
    paper: ({ theme }) => dropdownPaperStyles(theme),
    list: ({ theme }) => ({
      padding: theme.spacing(1),
      // This is a hack to prevent added padding in MuiSelect when it scrolls
      paddingRight: theme.spacing(1) + " !important",
    }),
  },
};
